export const domainToSid = {
  com: 'wcon_en',
  ua: 'wcon_uk',
};
